export enum CONTRACT_STATUS {
  new = 'NEW',
  suspended = 'SUSPENDED',
  // CANCELLED = 'CANCELLED',
  active = 'ACTIVE',
}
